import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "loading", "hasItems", "children"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Spinner } from "../../Spinner";
import styles from "./styles.pcss";
var cnActionSheetWrapper = cnBem('action-sheet--wrapper', styles);
export var ActionSheetWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    loading = props.loading,
    hasItems = props.hasItems,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnActionSheetWrapper({
      loading: loading,
      hasItems: hasItems
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "ActionSheet-ActionSheetWrapper"
  }), loading ? /*#__PURE__*/React.createElement("div", {
    className: cnActionSheetWrapper('loader')
  }, /*#__PURE__*/React.createElement(Spinner, {
    "aria-label": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0441\u043F\u0438\u0441\u043A\u0430",
    view: "yellow-white"
  })) : children);
});